import {
  AppLauncherConfig,
  LauncherIconCustomLink,
  LaunchLinkType,
  LinkAction,
  SocialLinkType,
} from "@store-platform/types"
import { FC, SVGProps } from "react"
import { SvgArrowUpRight, SvgDownload } from "@store-platform/ui/icons"
import {
  LauncherCustomLinkIcons,
  LaunchLinkIcon,
  SocialLinkIcon,
} from "./config"

export function getActionIcon(action: LinkAction): FC<SVGProps<SVGSVGElement>> {
  switch (action) {
    case "open":
      return SvgArrowUpRight
    case "download":
      return SvgDownload
  }
}

export function getLinkIconId<T extends keyof AppLauncherConfig["links"]>(
  collection: T,
  key: T extends "social"
    ? SocialLinkType
    : T extends "launch"
      ? LaunchLinkType
      : LauncherIconCustomLink["icon"],
): string {
  return `${collection}/${key}`
}

export function getLinkIconById(id: string): FC<SVGProps<SVGSVGElement>> {
  const split = id.split("/")
  switch (split[0]) {
    case "social":
      return SocialLinkIcon[split[1] as SocialLinkType]
    case "launch":
      return LaunchLinkIcon[split[1] as LaunchLinkType]
    default:
      return (
        LauncherCustomLinkIcons[split[1] as LauncherIconCustomLink["icon"]]
          ?.icon ?? LauncherCustomLinkIcons.globe.icon
      )
  }
}
